<template>
  <div class="main-container1 fund-manage">
    <!--查询条件 -->
    <query-condition-box>
      <el-form
        :inline="true"
        size="small"
        :model="queryParams"
        class="demo-form-inline"
      >
        <el-row>
          <el-col :span="24">
            <datePicker @changeDate="changeDate"></datePicker>
          </el-col>
        </el-row>
        <!--        <el-row>-->
        <!--          <el-col :span="24"-->
        <!--            ><el-form-item label="分类：">-->
        <!--              <el-radio-group-->
        <!--                v-model="queryParams.classify"-->
        <!--                size="small"-->
        <!--                @change="getStatusList"-->
        <!--              >-->
        <!--                <el-radio-button label="1">资料</el-radio-button>-->
        <!--                <el-radio-button label="2">专辑</el-radio-button>-->
        <!--              </el-radio-group>-->
        <!--            </el-form-item>-->
        <!--          </el-col>-->
        <!--        </el-row>-->
        <el-row>
          <el-col :span="24">
            <el-form-item label="状态：">
              <el-radio-group v-model="queryParams.status" size="small">
                <el-radio-button
                  v-for="item in statusList"
                  :key="item.id"
                  :label="item.id"
                  >{{ item.name }}
                </el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="queryParams.status === 2">
              <el-input
                v-model.trim="queryParams.title"
                style="width: 200px"
                placeholder="请输入专辑名称"
              ></el-input>
            </el-form-item>
            <el-form-item v-if="queryParams.status === 2">
              <el-input
                v-model.trim="queryParams.uploader"
                style="width: 200px"
                placeholder="请输入上传人用户名"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="onClickQuery"
                >查询
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-download"
                @click="exportExcel"
                >导出
              </el-button>
            </el-form-item>
            <el-form-item
              v-if="false"
              style="float: right !important; margin-right: 0 !important"
            >
              <el-button
                type="primary"
                icon="el-icon-upload2"
                @click="goUploadRes"
                size="small"
                >创建专辑
              </el-button>
            </el-form-item>
            <!--            <span>-->
            <!--              <el-button-->
            <!--                style="float: right"-->
            <!--                type="primary"-->
            <!--                icon="el-icon-upload2"-->
            <!--                @click="goUploadRes"-->
            <!--                size="small"-->
            <!--                >上传资源-->
            <!--              </el-button>-->
            <!--            </span>-->
            <auth-dialog
              :dialog-visible.sync="auth.flag"
              :tip-type="auth.tipType"
            ></auth-dialog>
          </el-col>
        </el-row>
      </el-form>
    </query-condition-box>
    <!-- 列表展示 -->
    <div class="result-container">
      <!--资料列表 -->
      <xkw-table
        v-if="this.tableTab == 1"
        v-loading="loading"
        ref="list-table"
        :data="resourceList"
      >
        <el-table-column prop="id" label="资料ID" width="150px" align="center">
          <template slot-scope="{ row }">
            {{ row.id }}
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题" width="500">
          <template slot-scope="{ row }">
            <div class="resource-title-box">
              <p class="title">
                <icon-type
                  :type="
                    row.ext == 'word' ||
                    row.ext == 'ppt' ||
                    row.ext == 'xls' ||
                    row.ext == 'pdf'
                      ? row.ext
                      : row.ext == 'docx' ||
                        row.ext == 'doc' ||
                        row.ext == 'rtf' ||
                        row.ext == 'wps'
                      ? 'word'
                      : row.ext == 'pptx' ||
                        row.ext == 'ppt' ||
                        row.ext == 'dps'
                      ? 'ppt'
                      : row.ext == 'csv' || row.ext == 'xlsx' || row.ext == 'et'
                      ? 'xls'
                      : row.ext == 'zip' ||
                        row.ext == 'rar' ||
                        row.ext == '7z' ||
                        row.ext == 'gz'
                      ? 'compress'
                      : row.ext == 'png' || row.ext == 'jpg'
                      ? 'image'
                      : row.ext == 'mp3' ||
                        row.ext == 'wav' ||
                        row.ext == 'mid' ||
                        row.ext == 'wma'
                      ? 'audio'
                      : row.ext == 'mp4' ||
                        row.ext == 'wmv' ||
                        row.ext == 'flv' ||
                        row.ext == 'avi' ||
                        row.ext == 'mov' ||
                        row.ext == 'mpg' ||
                        row.ext == 'rm' ||
                        row.ext == 'rmvb' ||
                        row.ext == '3gp' ||
                        row.ext == 'mkv'
                      ? 'video'
                      : 'others'
                  "
                />
                {{ row.title }}
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="价格" width="150" align="center">
          <template slot-scope="{ row }">
            {{ row.price }}
          </template>
        </el-table-column>
        <el-table-column label="上传时间" align="center">
          <template slot-scope="scope">
            {{ scope.row.createTime.replace("T", " ") }}
          </template>
        </el-table-column>
        <el-table-column prop="fileSize" label="文件" align="center">
        </el-table-column>
        <el-table-column prop="status" label="状态" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.status == '已通过'">
              <el-link
                :underline="false"
                type="primary"
                size="small"
                @click="showEditPrice(row)"
                >定价</el-link
              >
            </span>
          </template>
        </el-table-column>
      </xkw-table>
      <!--专辑列表 -->
      <xkw-table
        v-if="this.tableTab == 2"
        v-loading="loading"
        ref="list-table"
        :data="resourceList"
      >
        <!--        <el-table-column label="专辑ID" width="100" align="center">-->
        <!--          <template slot-scope="{ row }">-->
        <!--            <p class="title">-->
        <!--              {{ row.id }}-->
        <!--            </p>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <el-table-column label="专辑名称" width="350">
          <template v-slot="scope">
            <el-link
              style="color: #606266"
              v-if="scope.row.status === '已通过'"
              type="primary"
              :underline="false"
              @click="openUrl(scope.row)"
              >{{ scope.row.title }}
            </el-link>
            <span v-if="scope.row.status !== '已通过'">{{
              scope.row.title
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fileSize"
          label="资源数量"
          align="center"
          width="100"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="albumViewCnt"
          label="专辑页浏览量"
          width="150"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="albumResViewCnt"
          label="专辑资料浏览量"
          width="150"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="albumDlCnt"
          label="专辑资料支付订单数"
          width="180"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="上传时间"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            {{ scope.row.createTime.replace("T", " ") }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="provider"
          label="上传人"
          width="160"
        >
        </el-table-column>
        <el-table-column prop="status" width="100" label="状态" align="center">
          <template v-slot="{ row }">
            <span>{{ row.status }}</span>
            <i
              v-if="row.status === '退稿' && row.rejectReason !== null"
              class="question-icon"
              @click="getDetail(row)"
            ></i>
          </template>
        </el-table-column>
        <el-table-column prop="money" label="操作" align="center">
          <template slot-scope="scope">
            <el-link
              @click="updateAlbum(scope.row)"
              type="primary"
              :underline="false"
              >修改
            </el-link>
            &nbsp;
            <el-link
              type="primary"
              @click="showAlbumInfo(scope.row)"
              :underline="false"
              >详情
            </el-link>
          </template>
        </el-table-column>
      </xkw-table>
      <xkw-pagination
        v-if="this.total > 0"
        :total="this.total"
        :page-size="this.queryParams.pageSize"
        :current-page="this.queryParams.pageIndex"
        @current-change="onPageChange"
      ></xkw-pagination>
    </div>
    <!-- 专辑详情 -->
    <el-dialog v-bind:title="albumTitle" :visible.sync="dialogFormVisible">
      <xkw-table :data="albumResourceData" border style="width: 100%">
        <!--        <el-table-column label="资源ID" width="150" align="center">-->
        <!--          <template slot-scope="scope"> {{ scope.row.id }}</template>-->
        <!--        </el-table-column>-->
        <el-table-column label="标题" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span class="overflow">
              {{ scope.row.title }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="价格" width="100" align="center">
          <template slot-scope="scope"> {{ scope.row.price }}</template>
        </el-table-column>
        <el-table-column
          label="上传时间"
          align="center"
          width="200px"
          style="padding: 0px"
        >
          <template slot-scope="scope">
            {{ scope.row.createTime.replace("T", " ") }}
          </template>
        </el-table-column>
        <!--        <el-table-column-->
        <!--          prop="fileSize"-->
        <!--          label="文件"-->
        <!--          align="center"-->
        <!--        ></el-table-column>-->
        <el-table-column width="100" prop="status" label="状态" align="center">
        </el-table-column>
      </xkw-table>
      <xkw-pagination
        v-if="albumResourceTotal > 0"
        :total="albumResourceTotal"
        :page-size="albumQueryParams.pageSize"
        @current-change="onPageChange"
      ></xkw-pagination>
    </el-dialog>
    <el-dialog title="资料定价" :visible.sync="dialogVisible" width="30%">
      <div class="one-line">
        <span style="color: red; margin-left: 60px">*</span>
        <span>价格</span>
        <span style="margin-left: 5px">
          <el-tooltip
            effect="dark"
            content="超出限制范围请联系运营处理"
            placement="top-start"
          >
            <el-button
              class="el-icon-question"
              style="padding: 0; border: 0; height: auto; position: relative"
            />
          </el-tooltip>
        </span>
        <span
          style="display: inline-block; margin-left: 50px"
          class="price-input"
        >
          <el-input size="small" v-model="newPrice"
        /></span>
        <span style="display: inline-block; margin-left: 10px">{{
          this.editPrice.unit
        }}</span>
      </div>
      <div class="one-line" style="margin-top: 10px">
        <span style="color: red; margin-left: 165px">
          <span v-if="editPrice.unit == '储值' && tipFlag">
            请输入0-10内的整数
          </span>
          <span v-else-if="editPrice.unit == '元' && tipFlag">
            请输入0-50内的整数
          </span>
        </span>
      </div>
      <div style="display: flex; justify-content: center; margin-top: 30px">
        <span style="text-align: center">
          <el-button type="primary" @click="updateDocumentPrice()" size="small"
            >确 定</el-button
          >
        </span>
      </div>
      <div style="display: flex; justify-content: center; margin-top: 30px">
        <span style="color: red; text-align: center"
          >每月可修改价格2次，为促进用户下载，请合理定价</span
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/assets/js/api";
import { isOpenPermissionDialog, objectToQueryString } from "@/assets/js/utils";
import AuthDialog from "@/components/auth-dialog.vue";
import shopCenterConst from "@/assets/js/shopCenterConst";
import datePicker from "@/components/common/date-picker.vue";

export default {
  components: { datePicker, AuthDialog },
  data() {
    return {
      auth: {
        flag: false,
        tipType: null,
      },
      tipFlag: false,
      //弹窗埋点
      pay_window_view: {
        $event_name: "shopcenter_res_price_change", //埋点名称
      },
      editBtn: false,
      newPrice: "",
      editPrice: { price: 0, unit: "" },
      editPriceRow: {},
      dialogVisible: false,
      albumTitle: "【专辑ID】专辑名称",
      resourceList: [],
      statusList: [
        { id: 0, name: "不限" },
        { id: 1, name: "待审核" },
        { id: 2, name: "已通过" },
        { id: 3, name: "退稿" },
      ],
      albumResourceData: [],
      //查询参数
      queryParams: {
        uploader: "",
        pageIndex: 1,
        pageSize: 10,
        //分类
        classify: 2,
        //状态
        status: 0,
        //查询时间
        time: "month",
        //起始日期
        from: "",
        //结束日期
        to: "",
        startTime: "",
        endTime: "",
        shopId: this.$store.state.user.userInfo.shopId,
      },
      albumQueryParams: {
        pageIndex: 1,
        pageSize: 10,
        bundleId: 0,
      },
      //是否加载中
      loading: false,
      dialogFormVisible: false,
      total: 0,
      albumResourceTotal: 0,
      tableTab: 1,
      setDate: {}, // 时间控件的时间段 默认传空对象即可
    };
  },
  mounted() {
    // this.setTime();
    this.queryList();
  },
  methods: {
    getDetail(row) {
      this.$confirm(row.rejectReason, "退稿原因", {
        dangerouslyUseHTMLString: true, // 是否将 message 属性作为 HTML 片段处理
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
    },
    async updateAlbum(row) {
      //  auth start;
      const type = isOpenPermissionDialog(this.$store.state.user.userInfo);
      if (type === 1 || type === 3) {
        this.auth.tipType = type;
        this.auth.flag = true;
        return;
      }
      //  auth end;
      const result = await this.$axios.get(
        api.shopResource.getAlbumDetail + "?albumId=" + row.id
      );
      if (result.result.status === "P1_0" || result.result.status === "P1_1") {
        this.$message.error("专辑入库中，请稍后修改");
        return;
      }
      console.log(result);
      // if (row.status === "退稿") {
      // }
      if (row.status === "已通过" && row.updateStatus === "已完成") {
        this.$message.error("专辑已完结，无法修改");
        return;
      }
      // if (row.status === "已通过") {
      //   this.$message.error("专辑已通过，无法修改");
      //   return;
      // }
      if (row.status === "退稿") {
        this.$message.error("专辑已退稿，无法修改");
        return;
      }
      let opt = 1;
      if (row.status === "待审核") {
        opt = 1;
      } else if (row.status === "退稿") {
        opt = 2;
      } else if (row.status === "已通过" && row.updateStatus === "更新中") {
        opt = 3;
      }
      this.$router.push({
        name: "resource-album-upload",
        params: {
          time: this.queryParams.time,
          from: this.queryParams.from,
          to: this.queryParams.to,
          status: this.queryParams.status,
          pageIndex: this.queryParams.pageIndex,
          title: this.queryParams.title,
        },

        query: {
          resourceId: row.id,
          operationType: opt,
        },
      });
    },
    openUrl(row) {
      window.open(`//www.zxxk.com/docpack/${row.id}.html`);
    },
    changeDate(e) {
      this.queryParams.startTime = e.startTime;
      this.queryParams.endTime = e.endTime;
    },
    async exportExcel() {
      if (!this.queryParams.startTime) {
        this.$message.error("请选择开始时间");
        return;
      }
      if (!this.queryParams.endTime) {
        this.$message.error("请选择结束时间");
        return;
      }
      let _that = this;
      _that.queryParams.pageIndex = 1;
      _that.setFromToTime();
      const resourceResult = await _that.$axios.post(
        api.resource.getResourceList,
        _that.queryParams
      );
      if (resourceResult.list == null || resourceResult.totalCount <= 0) {
        _that.$message.warning("无数据");
        return;
      } else if (resourceResult.totalCount >= shopCenterConst.excel.maxNum) {
        _that.$message.warning(shopCenterConst.excel.tip);
        return;
      }

      window.open(
        api.shopResource.exportAlbumList +
          "?" +
          objectToQueryString(_that.queryParams)
      );
    },
    async updateDocumentPrice() {
      if (this.editPrice.price == this.newPrice) {
        this.dialogVisible = false;
        this.$message.success("资料价格调整成功");
        return true;
      }
      if (this.editPrice.unit == "储值") {
        //0-10范围内的整数
        if (
          !(
            this.newPrice % 1 === 0 &&
            this.newPrice >= 0 &&
            this.newPrice <= 10
          )
        ) {
          this.tipFlag = true;
          return false;
        }
      } else if (this.editPrice.unit == "元") {
        //0-50范围内的整数
        if (
          !(
            this.newPrice % 1 === 0 &&
            this.newPrice >= 0 &&
            this.newPrice <= 50
          )
        ) {
          this.tipFlag = true;
          return false;
        }
      } else {
        var reg = "^\\d{1,10}([.]\\d{1,2})?$";
        var regExp = new RegExp(reg);
        var flag = regExp.test(this.newPrice);
        if (!flag) {
          this.$message.error("请填写正确的价格！");
          return false;
        }
      }
      var request = {
        documentId: this.editPriceRow.id,
        price: this.newPrice,
      };
      const result = await this.$axios.post(
        api.resource.updateDocumentPrice,
        request
      );
      if (result.valid) {
        if (result.result) {
          //在特定的时机发送数据
          window.easyData.send(this.pay_window_view);
          this.$message.success("资料价格调整成功，信息更新略有延迟");
          this.dialogVisible = false;
          return true;
        }
      }
      this.$message.error("资料价格调整失败，请联系客服");
    },
    getPrice() {
      var price = this.editPriceRow.price;
      if (!price) {
        return;
      }
      if (price.endsWith("元")) {
        this.editPrice.unit = "元";
        this.editPrice.price = price.replace("元", "");
      } else if (price.endsWith("储值")) {
        this.editPrice.unit = "储值";
        this.editPrice.price = price.replace("储值", "");
      } else if (price.endsWith("普通点")) {
        this.editPrice.unit = "普通点";
        this.editPrice.price = price.replace("普通点", "");
      } else if (price.endsWith("高级点")) {
        this.editPrice.unit = "高级点";
        this.editPrice.price = price.replace("高级点", "");
      }
      this.newPrice = this.editPrice.price;
    },
    async showEditPrice(param) {
      //  auth start;
      const type = isOpenPermissionDialog(this.$store.state.user.userInfo);
      if (type === 1 || type === 3) {
        this.auth.tipType = type;
        this.auth.flag = true;
        return;
      }
      //  auth end;
      const result = await this.$axios.get(
        api.resource.getUpdateDocumentPriceFrequency + "?documentId=" + param.id
      );
      if (result && result.valid) {
        if (result.result < 2) {
          this.editPriceRow = param;
          this.dialogVisible = true;
          this.getPrice();
          return;
        } else {
          this.$message.error("每月仅可修改价格2次!");
        }
      } else {
        this.$message.error("服务器错误，请联系客服！");
      }
    },
    //专辑资源分页方法
    onAlbumResourcePageChange(pageIndex) {
      this.albumQueryParams.pageIndex = pageIndex;
      this.getAlbumResourceList();
    },
    /*点击分页*/
    onPageChange(pageIndex) {
      this.queryParams.pageIndex = pageIndex;
      this.queryList();
    },
    //获取收支列表数据
    async queryList() {
      this.loading = true;
      this.setFromToTime();
      const resourceResult = await this.$axios.post(
        api.resource.getResourceList,
        this.queryParams
      );
      this.resourceList = resourceResult.list;
      this.total = resourceResult.totalCount;
      this.tableTab = this.queryParams.classify;
      this.loading = false;
    },
    //点击查询按钮
    onClickQuery() {
      if (!this.queryParams.startTime) {
        this.$message.error("请选择开始时间");
        return;
      }
      if (!this.queryParams.endTime) {
        this.$message.error("请选择结束时间");
        return;
      }
      // 将查询时间段 同步给时间控件（针对时间控件中时间段不完整的情况）
      this.setDate = {
        startTime: this.queryParams.startTime,
        endTime: this.queryParams.endTime,
        timeAlias: this.queryParams.time,
      };
      this.queryParams.pageIndex = 1;
      this.queryList();
    },
    /*设置开始时间和结束时间*/
    setTime() {
      let timeType = this.queryParams.time;
      var nowData = new Date();
      var startTime = new Date();
      if (timeType == "yesterday") {
        startTime = new Date(new Date().setDate(new Date().getDate() - 1));
      } else if (timeType == "week") {
        startTime = new Date(new Date().setDate(new Date().getDate() - 7));
      } else if (timeType == "month") {
        startTime = new Date(new Date().setMonth(new Date().getMonth() - 1));
      } else if (timeType == "threeMonthes") {
        startTime = new Date(new Date().setMonth(new Date().getMonth() - 3));
      } else if (timeType == "year") {
        startTime = new Date(new Date().setYear(new Date().getFullYear() - 1));
      }
      if (this.queryParams.startTime != null) {
        let month = startTime.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        let day = startTime.getDate();
        if (day < 10) {
          day = "0" + day;
        }
        this.queryParams.startTime =
          startTime.getFullYear() + "-" + month + "-" + day;
      }
      if (this.queryParams.endTime != null) {
        let month = nowData.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        let day = nowData.getDate();
        if (day < 10) {
          day = "0" + day;
        }
        this.queryParams.endTime =
          nowData.getFullYear() + "-" + month + "-" + day;
      }
    },
    //设置时间控件
    setFromToTime() {
      if (this.queryParams.startTime == null) {
        this.$message.error("请选择开始时间！");
        return;
      }
      if (this.queryParams.endTime == null) {
        this.$message.error("请选择结束时间！");
        return;
      }
      if (this.queryParams.startTime != null) {
        this.queryParams.from = this.queryParams.startTime + " 00:00:00";
      }
      if (this.queryParams.endTime != null) {
        this.queryParams.to = this.queryParams.endTime + " 23:59:59";
      }
    },
    //展示专辑的详情页
    showAlbumInfo(album) {
      //  auth start;
      const type = isOpenPermissionDialog(this.$store.state.user.userInfo);
      if (type === 1 || type === 3) {
        this.auth.tipType = type;
        this.auth.flag = true;
        return;
      }
      //  auth end;
      this.albumTitle = "【" + album.id + "】" + album.title;
      this.getAlbumResourceList(album.id);
    },
    //获取状态数据
    async getStatusList() {
      const statusResult = await this.$axios.post(
        api.resource.getStatusList + "?classify=" + this.queryParams.classify
      );
      if (statusResult.valid) {
        this.statusList = statusResult.result;
      }
    },
    //获取专辑详情资源集合
    async getAlbumResourceList(albumId) {
      this.$set(this.albumQueryParams, "bundleId", albumId);
      const albumResourceResult = await this.$axios.post(
        api.resource.getAlbumResourceList,
        this.albumQueryParams
      );
      this.albumResourceData = albumResourceResult.list;
      this.albumResourceTotal = albumResourceResult.totalCount;
      this.dialogFormVisible = true;
    },
    //跳转到用户中心上传资源页面
    goUploadRes() {
      //  auth start;
      const type = isOpenPermissionDialog(this.$store.state.user.userInfo);
      if (type === 1 || type === 3) {
        this.auth.tipType = type;
        this.auth.flag = true;
        return;
      }
      this.$router.push({
        name: "resource-album-upload",
        params: {
          time: this.queryParams.time,
          from: this.queryParams.from,
          to: this.queryParams.to,
          status: this.queryParams.status,
          pageIndex: this.queryParams.pageIndex,
          title: this.queryParams.title,
        },
      });
      //  auth end;
    },
  },
};
</script>

<style lang="scss" scoped>
.question-icon {
  display: inline-block;
  width: 14px;
  height: 14px;
  background-image: url(../../../assets/images/question-circle.png);
  background-size: contain;
  background-repeat: no-repeat;
  vertical-align: middle;
  cursor: pointer;
  margin-bottom: 2px;
  margin-left: 2px;
}

.result-container {
  padding: 20px;
  background: #fff;
  border-radius: 5px;
}

.property {
  font-size: 14px;
  color: #666;
  margin-right: 20px;
}

.free {
  color: #5a83ff;
}

//::v-deep .has-gutter .el-table__cell {
//  &:first-of-type {
//    text-align: left !important;
//  }
//}
::v-deep .el-table thead {
  color: #333 !important;
}

::v-deep .el-table .cell.el-tooltip {
  width: 100% !important;
}
</style>
<style lang="css">
.price-input .el-input__inner {
  width: 150px;
}

.overflow {
  width: 80%;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
  height: 25px;
  line-height: 25px;
  vertical-align: middle;
}
</style>
